import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import { packingTypes, sizeOptions, siteOptions, outputOptions } from '../../constants/options';

const PackingSection = ({ formData, handleChange, handleSignatureOpen }) => {
  const packingKeys = [1, 2, 3, 4, 5, 6];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 6: Packing / Drains / Catheters / Irrigation Fluids
      </Typography>
      
      <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Size</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Site</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Output</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Signature</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {packingKeys.map((i) => {
              const signatureKey = i === 1 ? 'packing_sign' : `packing_sign${i}`;
              return (
                <TableRow key={i}>
                  <TableCell>
                    <Autocomplete
                      freeSolo
                      size="small"
                      options={packingTypes.map(opt => opt.label)}
                      value={formData.packing_type[`packing_type_${i}`] || ''}
                      onChange={(_, newVal) => handleChange({ target: { name: `packing_type.packing_type_${i}`, value: newVal } })}
                      renderInput={(params) => <TextField {...params} variant="standard" fullWidth />}
                    />
                  </TableCell>
                  <TableCell>
                    <Autocomplete
                      freeSolo
                      size="small"
                      options={sizeOptions.map(opt => opt.label)}
                      value={formData.packing_size[`packing_size_${i}`] || ''}
                      onChange={(_, newVal) => handleChange({ target: { name: `packing_size.packing_size_${i}`, value: newVal } })}
                      renderInput={(params) => <TextField {...params} variant="standard" fullWidth />}
                    />
                  </TableCell>
                  <TableCell>
                    <Autocomplete
                      freeSolo
                      size="small"
                      options={siteOptions.map(opt => opt.label)}
                      value={formData.packing_site[`packing_site_${i}`] || ''}
                      onChange={(_, newVal) => handleChange({ target: { name: `packing_site.packing_site_${i}`, value: newVal } })}
                      renderInput={(params) => <TextField {...params} variant="standard" fullWidth />}
                    />
                  </TableCell>
                  <TableCell>
                    <Autocomplete
                      freeSolo
                      size="small"
                      options={outputOptions.map(opt => opt.label)}
                      value={formData.packing_output[`packing_output_${i}`] || ''}
                      onChange={(_, newVal) => handleChange({ target: { name: `packing_output.packing_output_${i}`, value: newVal } })}
                      renderInput={(params) => <TextField {...params} variant="standard" fullWidth />}
                    />
                  </TableCell>
                  <TableCell sx={{ width: 120, textAlign: 'center' }}>
                    <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={() => handleSignatureOpen(signatureKey)}
                        sx={{ fontSize: '0.75rem', py: 0.5 }}
                    >
                        Sign
                    </Button>
                    {formData[signatureKey] && (
                        <Box sx={{ mt: 1, border: "1px solid #ccc", borderRadius: 1, p: 0.5 }}>
                            <img src={`data:image/png;base64,${formData[signatureKey]}`} alt="Sign" style={{ width: '100%', maxHeight: '40px' }} />
                        </Box>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PackingSection;
